import React, { forwardRef } from 'react';

import AutosizeInput from 'react-input-autosize';

import { AutoSizeTextFieldContainer } from './AutoSizeTextField.style';

export type AutoSizeTextFieldProps = {
  placeholder?: string;
  isError?: boolean;
  [x: string]: any;
};

export const AutoSizeTextField = forwardRef<HTMLHeadingElement, AutoSizeTextFieldProps>((props, ref) => {
  const { placeholder, isError, ...args } = props;
  return (
    <AutoSizeTextFieldContainer isError={isError}>
      <AutosizeInput
        style={{
          width: '100%',
        }}
        ref={ref as any}
        className="auto_size_text_field"
        maxLength={36}
        inputStyle={{}}
        placeholderIsMinWidth
        placeholder={placeholder}
        {...args}
      />
    </AutoSizeTextFieldContainer>
  );
});
